var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllocated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 66.6673C55.6023 66.6673 59.7689 64.8018 62.785 61.7857C65.8011 58.7697 67.6666 54.603 67.6666 50.0007C67.6666 45.3983 65.8011 41.2317 62.785 38.2155C59.7689 35.1995 55.6023 33.334 50.9999 33.334C46.3976 33.334 42.2309 35.1995 39.2148 38.2155C36.1987 41.2317 34.3333 45.3983 34.3333 50.0007C34.3333 54.603 36.1987 58.7697 39.2148 61.7857C42.2309 64.8018 46.3976 66.6673 50.9999 66.6673Z",
    fill: "#50D6B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 50L49.3333 55L59.3333 45",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocated);
export default __webpack_public_path__ + "static/media/Allocated.8f9bdfee.svg";
export { ForwardRef as ReactComponent };